import { SET_SIDEBAR_ACTIVE_TAB } from "redux/types";

const setSidebarActiveTab = (activeTab) => ({
    payload: { activeTab },
    type: SET_SIDEBAR_ACTIVE_TAB,
});

export default setSidebarActiveTab;
